<template>
  <TransactionListTemplate
    :screen-config="setScreenConfig"
    :row-click="rowClickCallBack"
    persistence-key="Process-Capacity-list"
    :setLoading="setLoading"
    ref="process-capacity-list"
  >
    <template #popup>
      <gcPopupShifts
        :popupConfig="shiftsPopupConfig"
        :data-model="dataModel"
        :on-hide="onShiftsPopupHide"
        v-if="shiftsPopupConfig.isPopupShow"
        :displayServerError="displayServerErrorOnTemplate"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";

import TransactionListTemplate from "@/templates/transaction-list";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import {
  GetIndexByTabName,
  ProcessCapacityTabs,
} from "../../../_models/tabdata/production/process-capacity";

import gcPopupShifts from "../../../popups/production/gc-popup-shifts.vue";
import { ProcessCapacityService } from "../../../_services/api/production/process-capacity.service";
import { IsResponseDataValid } from "../../../_helpers/ui/helpers";
import { FeatureStorage } from "../../../_services/storage";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
    gcPopupShifts,
  },
  data() {
    return {
      setLoading: false,
      dataModel: undefined,
      shiftsPopupConfig: {
        title: "",
        secondaryTitle: undefined,
        isFormLoading: false,
        popupKey: 0,
        formKey: 0,
        height: 370,
        isPopupShow: false,
        hideOnOutsideClick: false,
        formMode: "edit",
        isEditable: false,
      },
    };
  },
  computed: {
    setScreenConfig() {
      return {
        title: "Process Capacity",
        ScreenName: "Process Capacity",
        exportFileName: "Process Capacity List",
        selectedIndex: GetIndexByTabName("Shifts"),
        tabs: ProcessCapacityTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ShiftList",
              //   filter: [
              //     [["WOType", "=", "Production"], "or", ["WOType", "=", null]],
              //   ],
              serverPaging: true,
              allowGrouping: false,
              keyType: {
                ...this.getAttributeKeyTypes(),
              },
              postProcessCallback: this.postProcessCallback,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Process Capacity",
                message: "Get Started, Add a Process Capacity",
              },
            },
            // options: {
            //   selectionMode: "multiple",
            // },
          },
          toolbar: {
            screenName: "Process Capacity",
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            multiplePdf: true,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                clickAction: () => {
                  this.onNewShiftsHandler();
                },
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission(
                  "ProcessCapacity",
                  "create",
                ),
                // disabled: true,
              },
            ],
          },
          columns: [
            {
              screenField: "Shift",
              dataField: "Code",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              sortOrder: "desc",
              type: "Text",
            },
            {
              screenField: "ItemDescription",
              dataField: "SearchText",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 0,
              type: "Text",
              filterLabel: "Shift",
              filterDataField: "SearchText",
            },
            {
              screenField: "StartTime",
              label: "Start",
              filterLabel: "Start",
              dataField: "StartTime",
              minWidth: ColumnWidth.Time.minWidth,
              width: ColumnWidth.Time.width,
              filterIndex: 1,
              type: "Time",
              dataType: "datetime",
              displayFormat: "HH:mm",
            },
            {
              screenField: "EndTime",
              dataField: "EndTime",
              label: "End",
              filterLabel: "End",
              minWidth: ColumnWidth.Time.minWidth,
              width: ColumnWidth.Time.width,
              filterIndex: 2,
              type: "Time",
              displayFormat: "HH:mm",
            },

            {
              screenField: "DownTimeHrs",
              minWidth: ColumnWidth.Quantity.minWidth,
              width: ColumnWidth.Quantity.width,
              filterIndex: 3,
              // type: "Integer",
              intOperators: true,
            },
            {
              screenField: "AvailableShiftHrs",
              minWidth: ColumnWidth.Time.minWidth,
              width: ColumnWidth.Time.width,
            },
            {
              screenField: "ProcessCount",
              minWidth: ColumnWidth.Time.minWidth,
              width: ColumnWidth.Time.width,
            },
            {
              screenField: "ProcessList",
              gridDataField: "ProcessesList",
              filterDataField: "ProcessesList",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 4,
              filterOperator: "contains",
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 5,
            },
          ],
        },
      };
    },
  },
  created() {},
  methods: {
    /**
     * Show Loading
     * @param value
     * @constructor
     */
    ShowLoading(value) {
      this.setLoading = value;
    },
    /**
     * On Row Click CallBack
     * @param e
     */
    // eslint-disable-next-line no-unused-vars
    async rowClickCallBack(e) {
      if (e.rowIndex === -1 || e.rowType !== "data") return;
      this.ShowLoading(true);
      await ProcessCapacityService.getShiftByCode(e.data.Code)
        .then((response) => {
          if (IsResponseDataValid(response)) {
            this.ShowLoading(false);
            this.dataModel = response.data.value[0];
            this.shiftsPopupConfig.isPopupShow = true;
            this.shiftsPopupConfig.formMode = "review";
            this.shiftsPopupConfig.title = `Shift - ${e.data.Code}`;
          }
        })
        .catch((error) => {
          this.displayServerError(error);
          this.ShowLoading(false);
        });
    },

    /*
     * Post Process Callback
     * @param data
     */
    postProcessCallback(data) {
      data.forEach((element) => {
        element.DisplayStartTime = this.timeStringToDate(element.StartTime);
        element.DisplayEndTime = this.timeStringToDate(element.EndTime);
      });

      return data;
    },

    /**
     * Normalize Time String
     * @param timeStr
     */
    normalizeTimeString(timeStr) {
      if (!timeStr) return null;

      const parts = timeStr.split(":");
      if (parts.length !== 2) return null;

      let [h, m] = parts;

      h = h.padStart(2, "0");
      m = m.padStart(2, "0");

      return `${h}:${m}`;
    },

    /**
     * Time String to Date
     * @param timeStr
     */
    timeStringToDate(timeStr) {
      const normalized = this.normalizeTimeString(timeStr);
      if (!normalized) return null;

      const [h, m] = normalized.split(":");
      const d = new Date();
      d.setHours(+h, +m, 0, 0);

      return d;
    },

    // Shift Note Popup Methods
    // eslint-disable-next-line no-unused-vars
    onShiftsPopupHide(repaint = true) {
      this.shiftsPopupConfig.isPopupShow = false;
      this.dataModel = undefined;

      if (repaint) {
        this.$refs["process-capacity-list"].$refs[
          "transactionListGrid"
        ].gridRefresh();
      }
    },

    onNewShiftsHandler() {
      this.shiftsPopupConfig.isPopupShow = true;
      this.shiftsPopupConfig.formMode = "create";
      this.shiftsPopupConfig.title = "Create New Shift";
    },

    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },
  },
};
</script>

<style lang="scss"></style>
